import { Validators } from '@angular/forms';
import { BaseForm } from '../../core/forms/base.form';

export class AcademicTrainingDeclarationMultiForm extends BaseForm {

    constructor() {
        super();
        this.validationForm = this.formBuilder.group({
            range: [null, Validators.required],
            duration: [null, Validators.required],
            description: [null]
        });
    }

    public toRequestForm() {
        return {
            start: this.validationForm.get('range').value[0],
            end: this.validationForm.get('range').value[1],
            duration: this.validationForm.get('duration').value,
            description: this.validationForm.get('description').value,
        };
    }
}
